// component
// @ts-nocheck
import Iconify from '../../components/Iconify';
import { SIDEBAR } from '../../utils/userPermission';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const adminConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
    isAllow: SIDEBAR.DASHBORD_MENU,
  },

  {
    title: 'User Management',
    path: '/dashboard/user-management',
    icon: getIcon('bxs:user-plus'),
    isAllow: SIDEBAR.USER_MGMT_MENU,
  },

  // {
  //   title: 'Role Management',
  //   path: '/dashboard/role-management',
  //   icon: getIcon('eos-icons:role-binding'),
  // },

  {
    title: 'Vendor Profile',
    path: '/dashboard/vendor-details',
    icon: getIcon('mdi:account-details'),
    isAllow: SIDEBAR.VENDOR_MENU,
  },

  {
    title: 'Driver Profile',
    path: '/dashboard/driver-details',
    icon: getIcon('mdi:card-account-details-outline'),
    isAllow: SIDEBAR.DRIVER_MENU,
  },

  {
    title: 'Customer Profile',
    path: '/dashboard/customer-details',
    icon: getIcon('bi:person-circle'),
    isAllow: SIDEBAR.CUSTOMER_MENU,
  },

  {
    title: 'Blogs',
    path: '/dashboard/blogs',
    icon: getIcon('fontisto:blogger'),
    isAllow: SIDEBAR.BLOG_MENU,
  },
  {
    title: 'Payment Method',
    path: '/dashboard/payments-method',
    icon: getIcon('mdi:account-payment'),
    isAllow: SIDEBAR.NOTE_MENU,
  },

  // {
  //   title: 'Parking Overview',
  //   path: '/dashboard/all-parking-spaces',
  //   icon: getIcon('fa-solid:parking'),
  //   isAllow: SIDEBAR.PARKING_SPACE_MENU,
  // },
  {
    title: 'Vehicle Overview',
    path: '/dashboard/all-vehicle-spaces',
    icon: getIcon('fluent:vehicle-car-profile-20-filled'),
    isAllow: SIDEBAR.PARKING_SPACE_MENU,
  },

  {
    title: 'Booking Overview',
    path: '/dashboard/all-bookings',
    icon: getIcon('eva:calendar-outline'),
    isAllow: SIDEBAR.BOOKING_MENU,
  },

  {
    title: 'Revenue Overview',
    path: '/dashboard/admin-revenue',
    icon: getIcon('fa6-solid:money-check-dollar'),
    isAllow: SIDEBAR.REVENUE_MENU,
  },

  {
    title: 'City Overview',
    path: '/dashboard/cities',
    icon: getIcon('fa-solid:city'),
    isAllow: SIDEBAR.CITY_MENU,
  },

  {
    title: 'Offer Overview',
    path: '/dashboard/offers',
    icon: getIcon('fa-solid:gift'),
    isAllow: SIDEBAR.OFFER_MENU,
  },

  {
    title: 'Service Type',
    path: '/dashboard/service-type',
    icon: getIcon('fa-solid:car-side'),
    isAllow: SIDEBAR.Service_TYPE_MENU,
  },

  {
    title: 'Testimonials',
    path: '/dashboard/testimonial',
    icon: getIcon('mdi:feedback-outline'),
    isAllow: SIDEBAR.OFFER_MENU,
  },


  // {
  //   title: 'Wallet Management',
  //   path: '/dashboard/wallet-management',
  //   icon: getIcon('fa-solid:wallet'),
  // },

  // {
  //   title: 'Service Type',
  //   path: '/dashboard/service-type',
  //   icon: getIcon('fa-solid:car-side'),
  //   isAllow: SIDEBAR.PARKING_TYPE_MENU,
  // },

 // {
 //   title: 'Notes Overview',
 //   path: '/dashboard/notes',
 //   icon: getIcon('mdi:note-multiple-outline'),
//    isAllow: SIDEBAR.NOTE_MENU,
 // },

  {
    title: 'Customer Support Overview',
    path: '/dashboard/customer-support',
    icon: getIcon('ri:customer-service-2-fill'),
    isAllow: SIDEBAR.NOTE_MENU,
  },
 // {
 //   title: 'Pos Device',
 //   path: '/dashboard/pos-device',
 //   icon: getIcon('fontisto:shopping-pos-machine'),
 //   isAllow: SIDEBAR.NOTE_MENU,
 // },

  // {
  //   title: 'Statistics',
  //   path: '/dashboard/admin-statistics',
  //   icon: getIcon('mdi:chart-line'),
  // },

  // {
  //   title: 'Parking Types',
  //   path: '/dashboard/parking-types',
  //   icon: getIcon('fa-solid:car-side'),
  // },

  // {
  //   title: 'Commission Management',
  //   path: '/dashboard/commission-management',
  //   icon: getIcon('cil:library-building'),
  // },

  // {
  //   title: 'Vendor Flagging',
  //   path: '/dashboard/vendor-flagging',
  //   icon: getIcon('fa-solid:flag'),
  // },
];

export default adminConfig;
